import { render } from "./Caverns.vue?vue&type=template&id=3ea404be&scoped=true"
import script from "./Caverns.vue?vue&type=script&lang=js"
export * from "./Caverns.vue?vue&type=script&lang=js"

import "./Caverns.vue?vue&type=style&index=0&id=3ea404be&scoped=true&lang=css"

import exportComponent from "/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ea404be"]])

export default __exports__